import Page from '@admin/components/page'
import TeamToken from '@admin/tokens/team'
import React from 'react'

const mapPropsToPage = (props, context) => ({
  title: 't(Signups)',
  collection: {
    endpoint: '/api/admin/dashboards/affiliate_signups',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Advisor)', key: 'team.title', sort: 'team', primary: true, format: (advisor) => <TeamToken { ...advisor.team } /> },
      { label: 't(Signed Up)', key: 'created_at', sort: 'signed_up_at', collapsing: true,  format: 'datetime' }
    ],
    defaultSort: { key: 'created_at', order: 'desc' },
    empty: {
      svg: 'square_check',
      title: 't(No Signups)',
      text: 't(No one has signed up yet)'
    },
    entity: 'signup'
  }
})

export default Page(null, mapPropsToPage)
